import { Routes } from '@angular/router';
import { BienvenidaGuard } from './core/guards/bienvenida.guard';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    // loadComponent: () => import('./pages/bienvenida/bienvenida.page').then( m => m.BienvenidaPage),
   /// loadComponent: () => import('./auth/login/login.page').then( m => m.LoginPage)
    // canActivate: [BienvenidaGuard]
    loadComponent: () => import('./pages/handler/handler.component').then( m => m.HandlerComponent)
  },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
    canActivate: [AuthGuard],
  },
  {
    path: 'signin',
    loadComponent: () => import('./auth/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'signin/:email/:name/:date/:place',
    loadComponent: () => import('./auth/login/login.page').then( m => m.LoginPage)
  },
  {
    path: 'signup',
    loadComponent: () => import('./auth/signup/signup.page').then( m => m.SignupPage)
  },
  {
    path: 'signing/:isauto/:email/:name/:date/:place',
    loadComponent: () => import('./auth/signup/signup.page').then( m => m.SignupPage)
  },
  {
    path: 'events',
    redirectTo: 'tabs/inicio',
    pathMatch: 'full',
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./auth/reset-password/reset-password.page').then( m => m.ResetPasswordPage)
  },
  {
    path: 'complete-account',
    loadComponent: () => import('./auth/complete-account/complete-account.page').then( m => m.CompleteAccountPage)
  },
  {
    path: 'invitar/:id',
    loadComponent: () => import('./pages/invite/invite.page').then( m => m.InvitePage)
  },
  {
    path: 'payment/success',
    loadComponent: () => import('./pages/payment-status/payment-status.page').then( m => m.PaymentStatusPage),
    data: { status: 'success' }
  },
  {
    path: 'payment/pending',
    loadComponent: () => import('./pages/payment-status/payment-status.page').then( m => m.PaymentStatusPage),
    data: { status: 'pending' }
  },
  {
    path: 'payment/failure',
    loadComponent: () => import('./pages/payment-status/payment-status.page').then( m => m.PaymentStatusPage),
    data: { status: 'failure' }
  },
  {
    path: '**',
    redirectTo: '', // fallback a bienvenida si no se encuentra
  },
  // {
  //   path: '',
  //   redirectTo: '',
  //   pathMatch: 'full',
  // },
];
